import React, { ComponentProps as CP } from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'
import ListItemText from '@material-ui/core/ListItemText'
import Jersey, { JerseyPlaceholder } from 'components/Jersey'
import { IJersey } from 'protos'

interface StoryData extends Pick<CP<typeof Jersey>, 'size'> {
  text: string
  jersey: IJersey
}

const itemStyle: React.CSSProperties = {
  textAlign: 'center',
}

const storyData: { [key: string]: StoryData[] } = {
  default: [{
    size: 'small',
    text: 'small',
    jersey: {},
  }, {
    size: 'medium',
    text: 'medium (default)',
    jersey: {},
  }, {
    size: 'large',
    text: 'large',
    jersey: {},
  }],
  colored: [{
    size: 'small',
    text: 'small',
    jersey: {
      baseColor: 'FFEE44',
      sleeveColor: 'FF33AA',
      numberColor: '4499FF',
      jerseyNumber: '22',
    },
  }, {
    size: 'medium',
    text: 'medium (default)',
    jersey: {
      baseColor: 'FF0000',
      sleeveColor: 'FF0000',
      numberColor: 'FFFFFF',
      jerseyNumber: '5',
    },
  }, {
    size: 'large',
    text: 'large',
    jersey: {
      baseColor: '3388FF',
      sleeveColor: '2277FF',
      numberColor: 'FFAA00',
      jerseyNumber: '1',
    },
  }]
}

const Item: React.SFC<{ data: StoryData }> = ({ data: { size, jersey, text } }) => (
  <Grid style={itemStyle} item>
    <Jersey size={size} jersey={jersey} />
    <Typography>{text}</Typography>
  </Grid>
)

storiesOf('Jersey', module)
  .addDecorator((story) => (
    <Grid container>
      <Grid xs={12} item>
        <Grid spacing={2} alignItems="center" justify="space-around" container>
          {story()}
        </Grid>
      </Grid>
    </Grid>
  ))
  .add('default', () => <>{storyData.default.map((data, i) => <Item key={i} data={data} />)}</>)
  .add('colored', () => <>{storyData.colored.map((data, i) => <Item key={i} data={data} />)}</>)
  .add('/JerseyPlaceholder', () => (
    <>
      {storyData.default.map((data, i) => <JerseyPlaceholder size={data.size} key={i} />)}
    </>
  ))

storiesOf('Jersey/List', module)
  .add('default', () => (
    <List>
      {
        (new Array(100)).fill(0, 0, 100).map((_, i) => [
          <ListItem key={`item-${i}`}>
            <Jersey
              jersey={{
                baseColor: '3388FF',
                sleeveColor: '2277FF',
                numberColor: 'FFAA00',
                jerseyNumber: i.toString(),
              }}
            />
            <ListItemText primary="Sergio Ramos" secondary="Jan 9, 2014" />
          </ListItem>,
          <Divider key={`divider-${i}`} />
        ])
      }
    </List>
  ))
